module.exports = __webpack_public_path__ + "img/advantages_pca.089a829.svg";